import {NgModule} from '@angular/core';
import {ValidatorModule} from '@ngx-ivengi/cleanzone';
import {SharedModule} from '../shared/shared.module';
import {ProfileFormComponent} from './profile-form.component';
import {ProfileService} from './profile.service';

@NgModule({
  declarations: [
    ProfileFormComponent,
  ],
  exports: [
  ],
  imports: [
    SharedModule,
    ValidatorModule
  ],
  providers: [
    ProfileService
  ]
})
export class ProfileModule {

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/profile.module.ts